import Component, { Topic } from "component";
import { assert, parseHTML } from "utils";
import { ReqSection } from "constants";
var Url;
(function (Url) {
  Url["CHANGE"] = "change";
  Url["ADD"] = "add";
  Url["UPDATE"] = "update";
  Url["BASE"] = "base";
})(Url || (Url = {}));
export const CHANGE_URL_ATTR = "change-url";
export const ADD_URL_ATTR = "add-url";
export const UPDATE_URL_ATTR = "update-url";
export const CART_URL_ATTR = "cart-url";
export const DRAWER_ATTR = "drawer";
export const NOTIFICATION_ATTR = "notification";
export const IS_CART_PAGE_ATTR = "cart-page";
const URL_ATTS = {
  [Url.CHANGE]: CHANGE_URL_ATTR,
  [Url.ADD]: ADD_URL_ATTR,
  [Url.UPDATE]: UPDATE_URL_ATTR,
  [Url.BASE]: CART_URL_ATTR,
};
customElements.define(
  "x-cart-provider",
  class extends Component {
    constructor() {
      super();
    }
    fetchSections = new Set();
    withNotificator = false;
    ignoreNotifier = false;
    withDrawer = false;
    urls = {
      [Url.CHANGE]: "",
      [Url.ADD]: "",
      [Url.UPDATE]: "",
      [Url.BASE]: "",
    };
    render() {
      this.validateUrls();
      this.initFetchSections();
      this.sub(
        Topic.CART_ADD,
        ({ formData, TUID, ignoreNotifier }) => {
          this.ignoreNotifier = !!ignoreNotifier;
          this.addToCart(formData, TUID);
        },
        { global: true }
      );
      this.sub(
        Topic.CART_CHANGE,
        ({ id, qty, TUID, sectionId }) => {
          if (sectionId) {
            this.fetchSections.add(sectionId);
          }
          this.changeCart(id, qty, TUID);
        },
        { global: true }
      );
      this.sub(
        Topic.CART_NOTES,
        (notes) => {
          const res = fetch(this.urls[Url.UPDATE], {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              note: notes,
            }),
          }).catch(console.error);
        },
        { global: true }
      );
    }
    validateUrls() {
      let key;
      for (key in URL_ATTS) {
        if (!this.hasAttribute(URL_ATTS[key])) {
          assert(false, `Cart provider missing ${URL_ATTS[key]} attr`);
        }
        this.urls[key] = this.getAttribute(URL_ATTS[key]);
        if (key !== Url.BASE) {
          this.urls[key] += ".js";
        }
      }
    }
    initFetchSections() {
      if (this.hasAttribute(DRAWER_ATTR)) {
        this.fetchSections.add(ReqSection.CART_DRAWER);
        this.withDrawer = true;
      }
      if (this.hasAttribute(NOTIFICATION_ATTR)) {
        this.withNotificator = true;
      }
    }
    get sectionsList() {
      return Array.from(this.fetchSections).join(",");
    }
    async fetchCart(url, data) {
      if (url !== Url.ADD && url !== Url.CHANGE) {
        console.error("Wrong cart fetch url");
        return;
      }
      const fetchUrl = this.urls[url];
      let res;
      if (url === Url.CHANGE) {
        res = await fetch(fetchUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            ...data,
            sections: this.sectionsList,
            sections_url: this.urls[Url.BASE],
          }),
        });
      }
      if (url === Url.ADD) {
        data.append("sections", this.sectionsList);
        res = await fetch(fetchUrl, {
          method: "POST",
          headers: {
            ["X-Requested-With"]: "XMLHttpRequest",
          },
          body: data,
        });
      }
      const rData = await res.json();
      if (!res.ok) {
        throw new Error(rData.description);
      }
      return rData;
    }
    handleError(TUID, error) {
      console.error(error);
      this.pub(Topic.CART_UPDATE, {
        TUID,
        error: error.message,
      });
      if ("message" in error && typeof error.message === "string") {
        this.pub(Topic.SHOW_TOAST, {
          type: "error",
          msg: error.message,
        });
      }
    }
    getSectionsData(data) {
      const res = {};
      Object.keys(data.sections).forEach((sectionKey) => {
        res[sectionKey] = parseHTML(data.sections[sectionKey]);
      });
      return res;
    }
    async changeCart(id, quantity, TUID) {
      try {
        const data = await this.fetchCart(Url.CHANGE, { id, quantity });
        this.pub(Topic.CART_UPDATE, {
          TUID,
          data: {
            indicator: Number(data["item_count"]) > 0,
            openDrawer: false,
            sections: this.getSectionsData(data),
          },
        });
      } catch (e) {
        this.handleError(TUID, e);
      }
    }
    async addToCart(formData, TUID) {
      let useNotifier = this.withNotificator && !this.ignoreNotifier;
      try {
        // Check for setup fee requirement
        const variantId = formData.get("id");
        const quantity = parseInt(formData.get("quantity") || "1");

        // Get collection data from multiple sources
        let collections = formData.get("product_collections") || "";

        // Fallback 1: Try to get from x-product-form element
        if (!collections) {
          const productForm = document.querySelector(
            "x-product-form[data-product-collections]"
          );
          if (productForm) {
            collections =
              productForm.getAttribute("data-product-collections") || "";
          }
        }

        // Fallback 2: Try to get from form element's data attribute
        if (!collections) {
          const form = document
            .querySelector(
              `[data-product-form] input[name="id"][value="${variantId}"]`
            )
            ?.closest("form");
          const collectionInput = form?.querySelector(
            "[data-product-collections]"
          );
          if (collectionInput) {
            collections =
              collectionInput.value ||
              collectionInput.getAttribute("data-product-collections") ||
              "";
          }
        }

        let collectionsArray = collections
          ? collections.split(",").filter(Boolean)
          : [];
        let isHat1Collection =
          collectionsArray.includes("hat-1") ||
          collectionsArray.includes("hats-1");

        // Add main product to cart
        const data = await this.fetchCart(Url.ADD, formData);
        const sections = this.getSectionsData(data);

        console.log("Setup Fee Check:", {
          variantId,
          quantity,
          collections: collectionsArray,
          isHat1Collection,
          shouldAdd: isHat1Collection && quantity >= 12 && quantity <= 49,
        });

        // Add setup fee if conditions are met (hat-1 collection, quantity 12-49)
        if (isHat1Collection && quantity >= 12 && quantity <= 49) {
          // Setup fee product ID: 8896470155506
          // Try to get variant ID from product data
          const setupFeeProductId = "8896470155506";
          let setupFeeVariantId = null;

          // First, try to fetch product by ID using Shopify's product API
          try {
            const productResponse = await fetch(
              `/products/${setupFeeProductId}.js`
            );
            if (productResponse.ok) {
              const productData = await productResponse.json();
              // Get first available variant
              const availableVariant =
                productData.variants?.find((v) => v.available) ||
                productData.variants?.[0];
              setupFeeVariantId = availableVariant?.id?.toString();
            }
          } catch (e) {
            console.warn(
              "Could not fetch product by ID, trying direct variant:",
              e
            );
          }

          // If product fetch failed, try using the ID directly as variant ID
          if (!setupFeeVariantId) {
            setupFeeVariantId = setupFeeProductId;
          }

          // Check if setup fee is already in cart
          const cartResponse = await fetch(this.urls[Url.BASE] + ".js").catch(
            () => null
          );
          let setupFeeInCart = false;
          if (cartResponse && cartResponse.ok) {
            const cartData = await cartResponse.json();
            setupFeeInCart =
              cartData.items?.some(
                (item) =>
                  item.variant_id.toString() === setupFeeVariantId ||
                  item.product_id.toString() === setupFeeProductId
              ) || false;
          }

          // Add setup fee only if not already in cart
          if (!setupFeeInCart) {
            console.log("Adding setup fee variant:", setupFeeVariantId);
            const setupFeeFormData = new FormData();
            setupFeeFormData.append("id", setupFeeVariantId);
            setupFeeFormData.append("quantity", "1");
            setupFeeFormData.append("sections", this.sectionsList);

            try {
              const setupFeeData = await this.fetchCart(
                Url.ADD,
                setupFeeFormData
              );
              // Merge setup fee cart sections with main product sections
              const setupFeeSections = this.getSectionsData(setupFeeData);
              Object.assign(sections, setupFeeSections);
              console.log("Setup fee added successfully");
            } catch (setupFeeError) {
              console.error("Failed to add setup fee:", setupFeeError);
              // Try alternative: use product ID directly if variant ID failed
              if (setupFeeVariantId !== setupFeeProductId) {
                console.log("Retrying with product ID as variant ID");
                const retryFormData = new FormData();
                retryFormData.append("id", setupFeeProductId);
                retryFormData.append("quantity", "1");
                retryFormData.append("sections", this.sectionsList);
                try {
                  const retryData = await this.fetchCart(
                    Url.ADD,
                    retryFormData
                  );
                  const retrySections = this.getSectionsData(retryData);
                  Object.assign(sections, retrySections);
                  console.log("Setup fee added with product ID");
                } catch (retryError) {
                  console.error("Retry also failed:", retryError);
                }
              }
            }
          } else {
            console.log("Setup fee already in cart");
          }
        }

        if (this.withNotificator && !this.ignoreNotifier) {
          const notifierData = await this.getNotifierData(data.url);
          if (notifierData) {
            useNotifier = true;
            sections[ReqSection.PRODUCT_NOTIFIER] = notifierData;
          }
        }
        if (!useNotifier && !this.withDrawer) {
          window.location.href = this.urls[Url.BASE];
        }
        this.pub(Topic.CART_UPDATE, {
          TUID,
          data: {
            indicator: !!data,
            openDrawer: !useNotifier,
            sections,
          },
        });
      } catch (e) {
        this.handleError(TUID, e);
      }
    }
    async getNotifierData(productUrl) {
      try {
        const nres = await fetch(
          productUrl + `&sections=${ReqSection.PRODUCT_NOTIFIER}`
        );
        const ndata = await nres.json();
        return parseHTML(ndata[ReqSection.PRODUCT_NOTIFIER]);
      } catch (e) {
        console.error(e);
        return null;
      }
    }
  }
);
